import { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import UserContext from '../context/UserContext';
import LoginBanner from './LoginBanner';
import Loading from './Loading';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isLoggedIn, isAuthLoading } = useContext(UserContext);

  return (
    <Route
      {...rest}
      render={props => {
        if (isAuthLoading) {
          return (
            <div className="login-container">
              <LoginBanner />
              <Loading isLoading={isAuthLoading}/>
            </div>
          )
        }
        return isLoggedIn === true ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;

PrivateRoute.propTypes = {
  location: ReactRouterPropTypes.location,
  history: ReactRouterPropTypes.history,
  component: PropTypes.elementType,
};